module.exports = __webpack_public_path__ + "img/frame (183).13fbd244.jpg";